export const SET_TXN_PAYMENT_INSTRUMENTS =
	'userConfig/SET_TXN_PAYMENT_INSTRUMENTS';

export const SET_LIVE_TXN_FILTERS = 'userConfig/SET_LIVE_TXN_FILTERS';

export const SET_DASHBOARD_DATE_RANGE = 'userConfig/SET_DASHBOARD_DATE_RANGE';

export const GET_CHIMERA_CONFIG = 'userConfig/GET_CHIMERA_CONFIG';
export const GET_CHIMERA_CONFIG_SUCCESS =
	'userConfig/GET_CHIMERA_CONFIG_SUCCESS';
export const GET_CHIMERA_CONFIG_ERROR = 'userConfig/GET_CHIMERA_CONFIG_ERROR';
export const REMOVE_NOTIFICATION_WIDGET =
	'userConfig/REMOVE_NOTIFICATION_WIDGET';

export const SET_SELECTED_MERCHANTS = 'userConfig/SET_SELECTED_MERCHANTS';

export const RESET_USER_CONFIG = 'userConfig/RESET_USER_CONFIG';
